import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import MultiSelect from "components/Controls/MultiSelect/components/MultiSelect";
import { getCreateNewItemRenderer } from "components/Controls/MultiSelect/utils";
import { loadRsTags } from "store/global/global.actions";
import * as styles from "./styles.module.scss";
const TagsSelectInput = ({ value, items, forbiddenTagsNames, onChange, className, readonly, onFocus, onBlur, }) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const onTagSelect = useCallback((selectedTag) => {
        if (selectedTags.some((el) => el.label === selectedTag.label.trim())) {
            onChange(selectedTags);
        }
        else {
            const listItemsToKeep = tags.filter((tag) => tag.value !== selectedTag.value);
            setSelectedTags([...selectedTags, selectedTag]);
            setTags(listItemsToKeep);
            onChange([...selectedTags, selectedTag]);
        }
    }, [selectedTags, tags, onChange]);
    const onTagRemove = useCallback((label, index) => {
        const removedItem = selectedTags[index];
        if (removedItem.removable !== false) {
            const updatedSelectedTags = selectedTags.filter((tag) => tag.label !== label);
            setSelectedTags(updatedSelectedTags);
            setTags([...tags, removedItem].sort((a, b) => a.value - b.value));
            onChange(updatedSelectedTags);
        }
    }, [selectedTags, tags, onChange]);
    const handleClear = useCallback(() => {
        const filteredTags = selectedTags.filter(({ removable }) => removable === false);
        setSelectedTags(filteredTags);
        setTags(items);
        onChange(filteredTags);
    }, [items, onChange, selectedTags]);
    useEffect(() => setTags(items), [items]);
    useEffect(() => {
        if (value?.length > 0) {
            const flatFieldValues = value.map((tag) => tag.label);
            const updatedTagsList = items.filter((tag) => !flatFieldValues.includes(tag.label));
            setSelectedTags(value);
            setTags(updatedTagsList);
        }
    }, [items, value]);
    useEffect(() => {
        dispatch(loadRsTags());
    }, [dispatch]);
    return (React.createElement("div", { className: classNames(styles.field, className) },
        React.createElement(MultiSelect, { items: tags, selectedItems: value || [], onItemSelect: onTagSelect, handleClear: handleClear, onItemRemove: onTagRemove, onFocus: onFocus, onBlur: onBlur, classes: { className: styles.select }, createNewItemRenderer: getCreateNewItemRenderer(selectedTags, tags, forbiddenTagsNames), tagProps: (_, i) => ({
                intent: "none",
                minimal: false,
                ...(value[i]?.removable === false ? { onRemove: undefined } : {}),
            }), viewMode: readonly, resetOnSelect: true })));
};
export default TagsSelectInput;
